import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import Modal from 'components/Modal/Modal'
import Toast from 'components/Toast/Toast'

import AnalyticsMonitor from 'common/services/AnalyticsMonitor'

import { API__PAYMENTS, API__PRODUCTS } from 'api'

import ChooseCheckoutModal from './components/ChooseCheckoutModal/ChooseCheckoutModal'

import { ONE_TIME_PROJECT_CORRESPONDS, ONE_TIME_PROJECT_DESCRIPTION } from './constants'

import styles from './UpgradeProjectTariff.module.scss'

const UpgradeProjectTariff = ({ project, onClose }) => {
    const { t } = useTranslation()

    const [cards, setCards] = useState([])
    const [chooseCheckoutModal, setChooseCheckoutModal] = useState(null)

    useEffect(() => {
        API__PRODUCTS.GET_ONE_TIME_PRODUCTS().then(products => {
            products.sort((a, b) => a.purchasePrice - b.purchasePrice)
            setCards(products)
        })
    }, [])

    const onUpgrade = async isBusinessPayment => {
        try {
            const url = await API__PAYMENTS.GET_PAYMENT_LINK({
                productCode: chooseCheckoutModal.productCode,
                projectId: project.id,
                isBusinessPayment,
            })
            if (url) {
                window.location.href = String(url)
                setChooseCheckoutModal(null)
            }
        } catch (err) {
            console.error(err)
            Toast('error', {})
        }
    }

    return (
        <>
            <Modal isShowCloseIcon closeOnOverlayClick={false} closeOnEsc={false} onClose={onClose}>
                <div className={styles.upgradeProjectTariff}>
                    <h2 className={styles.title}>{t('Premium subscription for one project')}</h2>
                    <p className={styles.description}>
                        {t('You can purchase a subscription for one project for a month or more.')}
                    </p>
                    <p className={styles.description}>{t('Suitable for events and one-time promotions.')}</p>
                    <ul className={styles.productList}>
                        {cards.map(card => (
                            <li
                                key={card.id}
                                className={styles.cardItem}
                                style={{
                                    width: `${100 / cards.length}%`,
                                }}
                            >
                                <div className={styles.cardBox}>
                                    <div className={styles.cardInfo}>
                                        <div className={styles.planName}>{card.name}</div>
                                        <div className={styles.price}>
                                            <div className={styles.priceCurrency}>$</div>
                                            <div className={styles.priceValue}>{card.purchasePrice}</div>
                                            <div className={styles.cycle}>
                                                <div className={styles.cycleValue}>/{t('month')}</div>
                                            </div>
                                        </div>
                                        <div className={styles.cardDescription}>
                                            {ONE_TIME_PROJECT_DESCRIPTION[card.productCode]}
                                        </div>
                                        <div className={styles.corresponds}>
                                            {ONE_TIME_PROJECT_CORRESPONDS[card.productCode]}
                                        </div>
                                    </div>
                                    <button
                                        className={classNames(styles.upgradeButton, 'button')}
                                        data-size="lg"
                                        data-variant="primary"
                                        onClick={() => {
                                            AnalyticsMonitor.track('sendBuyMethodChoosingToAnalytics')
                                            setChooseCheckoutModal(card)
                                        }}
                                    >
                                        {t('Upgrade')}
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </Modal>
            {!!chooseCheckoutModal && (
                <ChooseCheckoutModal onClose={() => setChooseCheckoutModal(null)} onCheckout={onUpgrade} />
            )}
        </>
    )
}
export default UpgradeProjectTariff
